import styled, { css } from 'styled-components';
import Image from 'next/image';

export const Wrapper = styled.div(
  () => css`
    display: inline-flex;
    flex-direction: column;
    align-items: center;
  `,
);

export const DownloadWrapper = styled.div(
  ({ theme }) => css`
    margin-bottom: ${theme.sz.s2};
  `,
);

export const Stars = styled(Image)(() => css``);

export const Reviews = styled.a(
  ({ theme }) => css`
    display: inline-block;
    color: unset;
    text-decoration: none;
    ${theme.typography.heading.desktop.xxxs};

    &:hover {
      text-decoration: underline;
    }
  `,
);

export const Container = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: ${theme.sz.s4};

    @media (min-width: ${theme.sz.md}) {
      display: grid;
      grid-auto-columns: minmax(0, 1fr);
      grid-auto-flow: column;

      > *:first-child {
        margin-left: auto;
      }

      > *:last-child {
        margin-right: auto;
      }
    }
  `,
);
